import { Scene, Choice, Dialog } from "../models";
import { scenes } from "../scenes";

let burgerJointDialog = [
  new Dialog(
    "SONNY YANG: Hello chum. I’d like to order one of your FAMOUS BIG BURGERS please.",
    require("@/images/sonny.png"),
    require("@/audio/Pandemic-28-Sonny-1-MP3.mp3")
  ),
  new Dialog(
    "BURGER COOK: Alright, that’ll be $7.00 on PAY ’N GO.",
    require("@/images/Burger_Cook.png"),
    require("@/audio/Pandemic-28-Burger-Cook-1-MP3.mp3")
  ),
  new Dialog(
    "SONNY YANG: Oh my, it seems I only have cash on hand chum.",
    require("@/images/sonny.png"),
    require("@/audio/Pandemic-28-Sonny-2-MP3.mp3")
  ),
  new Dialog(
    "BURGER COOK: Sorry, we’re only accepting CONTACTLESS PAYMENTS at the moment in order to prevent contamination. Also, stop calling me ‘chum’.",
    require("@/images/Burger_Cook.png"),
    require("@/audio/Pandemic-28-Burger-Cook-2-MP3.mp3")
  ),
];

let burgerBuyingDialog = [
  new Dialog(
    "SONNY YANG: Hello chum, I’d like to purchase one of your FAMOUS BIG BURGERS via contactless payment please.",
    require("@/images/sonny.png"),
    require("@/audio/Pandemic-29-Sonny-MP3.mp3")
  ),
  new Dialog(
    "BURGER COOK: Great, just tap your card on the device.",
    require("@/images/Burger_Cook.png"),
    require("@/audio/Pandemic-29-Burger-Cook-1-MP3.mp3")
  ),
  new Dialog(
    "[USED CREDIT CARD]",
    require("@/images/Credit_Card.png"),
    require("@/audio/Found_Jingle.mp3")
  ),
  new Dialog(
    "BURGER COOK: Here you go, one FAMOUS BIG BURGER fresh off the grill",
    require("@/images/Burger_Cook.png"),
    require("@/audio/Pandemic-29-Burger-Cook-2-MP3.mp3")
  ),
  new Dialog(
    "[ACQUIRED 1 X HAMBURGER]",
    require("@/images/Burger.png"),
    require("@/audio/Found_Jingle.mp3")
  ),
];


export const limitConvo = [
  new Dialog(
    "SONNY YANG: Hello again chum. May I order a second FAMOUS BIG BURGER?",
    require("@/images/sonny.png"),
    require("@/audio/Pandemic-30-Sonny-MP3.mp3")

  ),
  new Dialog(
    "BURGER COOK: Sorry, we’ve implemented a ‘1 burger per customer for every 24 hour period policy’ due to high demand.",
    require("@/images/Burger_Cook.png"),
    require("@/audio/Pandemic-30-Burger-Cook-MP3.mp3")
  )
]
export class InsideBurgerJoint extends Scene {
  async init() {
    this.image = require("@/images/Burger_Joint_Interior.png");
    this.title = "Inside Burger Joint";
    this.audio = null;
    this.description = "";
  }

  get options() {
    return [
      new Choice("Order burger", async () => {
        if (this.state.inventory.burger.has) {
          await this.dialogRunner(limitConvo)
          this.init()
        } else if (this.state.inventory.creditCard.has) {
          await this.dialogRunner(burgerBuyingDialog)
          this.state.inventory.burger.has = true;
        } else {
          await this.dialogRunner(burgerJointDialog)
          if (this.state.storylines.fenceOpened) {
            this.state.storylines.findAtm = true
          }
        }
      }),
      new Choice("Leave Burger Joint", async () =>
        await this.navigate(scenes.BurgerJoint())
      ),
    ];
  }
}

export default new InsideBurgerJoint();
